import { setup } from "web/entrypoints/common/setup";

import "web/entrypoints/homepage/baustein-homepage";
import "./css-homepage-rebrand";
import classicComponents from "web/entrypoints/homepage/react-homepage";
import components from "./rebrand-homepage";

setup({ ...classicComponents, ...components });
